import { stringifyQs } from "@dashboard/utils/urls";
import urlJoin from "url-join";

import {
  type ActiveTab,
  type BulkAction,
  type Dialog,
  type Filters,
  type Pagination,
  type SingleAction,
  type Sort,
  type TabActionDialog,
} from "../types";

const customerSection = "/customers/";

export const customerListPath = customerSection;
export enum CustomerListUrlFiltersEnum {
  joinedFrom = "joinedFrom",
  joinedTo = "joinedTo",
  numberOfOrdersFrom = "numberOfOrdersFrom",
  numberOfOrdersTo = "numberOfOrdersTo",
  query = "query",
}
export type CustomerListUrlFilters = Filters<CustomerListUrlFiltersEnum>;
export type CustomerListUrlDialog = "remove" | TabActionDialog;
export enum CustomerListUrlSortField {
  name = "name",
  email = "email",
  orders = "orders",
}
type CustomerListUrlSort = Sort<CustomerListUrlSortField>;
export type CustomerListUrlQueryParams = ActiveTab &
  BulkAction &
  CustomerListUrlFilters &
  CustomerListUrlSort &
  Dialog<CustomerListUrlDialog> &
  Pagination;
export const customerListUrl = (params?: CustomerListUrlQueryParams) =>
  customerListPath + "?" + stringifyQs(params);

export const customerListB2bPath = urlJoin(customerSection, "b2b") + "/";
export const customerListB2bUrl = (params?: CustomerListUrlQueryParams) =>
  customerListB2bPath + "?" + stringifyQs(params);

export const customerListB2cPath = urlJoin(customerSection, "b2c") + "/";
export const customerListB2cUrl = (params?: CustomerListUrlQueryParams) =>
  customerListB2cPath + "?" + stringifyQs(params);

export const customerCartWishlistActivityPath =
  urlJoin(customerSection, "cart-wishlist-activity") + "/";
export type CustomerCartWishlistActivityUrlQueryParams = Pagination & { tab?: string };
export const customerCartWishlistActivityUrl = (
  params?: CustomerCartWishlistActivityUrlQueryParams,
) => customerCartWishlistActivityPath + "?" + stringifyQs(params);

export const customerPath = (id: string) => urlJoin(customerSection, id);
type CustomerUrlDialog = "remove";
export type CustomerUrlQueryParams = Dialog<CustomerUrlDialog>;
export const customerUrl = (id: string, params?: CustomerUrlQueryParams) =>
  customerPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const customerAddPath = urlJoin(customerSection, "add");
export const customerAddUrl = customerAddPath;

export const customerAddressesPath = (id: string) => urlJoin(customerPath(id), "addresses");
export type CustomerAddressesUrlDialog = "add" | "edit" | "remove";
export type CustomerAddressesUrlQueryParams = Dialog<CustomerAddressesUrlDialog> & SingleAction;
export const customerAddressesUrl = (id: string, params?: CustomerAddressesUrlQueryParams) =>
  customerAddressesPath(encodeURIComponent(id)) + "?" + stringifyQs(params);

export const customerCreditHistoryPath = (id: string) => urlJoin(customerPath(id), "credit-transactions");
export const customerCreditHistoryUrl = (id: string) =>
  customerCreditHistoryPath(encodeURIComponent(id));

export const customerPricingPath = (id: string) => urlJoin(customerPath(id), "pricing");
export type CustomerPricingUrlDialog = "add" | "edit" | "remove";
export type CustomerPricingUrlQueryParams = Dialog<CustomerPricingUrlDialog> & SingleAction;
export const customerPricingUrl = (id: string, params?: CustomerPricingUrlQueryParams) =>
  customerPricingPath(encodeURIComponent(id)) + "?" + stringifyQs(params);
